export const PENDING = 1
export const CONFIRMED = 2
export const REJECTED = 3
export const PREVALIDATED = 4


// WEBPACK FOOTER //
// ./src/constants/db/accreditationStates.js